<template>
  <div class="s-card">
    <slot></slot>
  </div>
</template>
